export default __webpack_public_path__ + "static/allo-e10a8bcaa0f007a4fafa8d80006bd66d.png";